import { transparentize } from "polished";
import styled from "styled-components";
import { LAYOUT } from "@/constants/styles";
import { getFontStyles } from "@/redux/cmsConfig/utils";
import { safePolished } from "@/utils/safePolished";

export const StyledSpecialInstructions = styled.p(({ theme }) => ({
  fontSize: "12px",
  marginTop: "20px",
  ...getFontStyles(theme.text.primary_font, ["color"], {
    color: (value) =>
      value ? safePolished(transparentize)("0.1", value) : "inherit",
  }),
}));

export const StyledAddressContainer = styled.div`
  padding: 0 ${LAYOUT.GUTTER}px;
  position: relative;

  &:not(:last-child) {
    ${({ theme }) => `
    border-bottom: 1px solid ${theme.checkout.border_color};
  `}
  }
`;

export const StyledAddressOptionsContainer = styled.div`
  position: absolute;
  top: -4px;
  right: ${LAYOUT.GUTTER / 2}px;
  display: flex;
  flex-direction: column;
`;
